// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3KVAa","filesListContainer":"PosDisputesFiles_filesListContainer__15jYe","filesButton":"PosDisputesFiles_filesButton__1FS67"};